export default __webpack_public_path__ + "static/media/project-bloom-landing-banner-dark.bb7bb650.svg";